import { makeAutoObservable, observable, reaction } from "mobx";
import moment from "moment";
import { v4 as uuid } from "uuid";
import { YYYYMMDD } from "../../utils/time.utils";
var defaultBaseCalendarStateOptions = observable({
    name: uuid(),
    startDate: moment().startOf('month').format(YYYYMMDD),
    mode: 'month',
    displayTimelinesInWeekMode: true,
    fullHeight: true,
    fitInnerToAvailableHeight: false,
    showEventEndTimes: false,
    eventTypeGroups: [],
});
var BaseCalendarState = /** @class */ (function () {
    function BaseCalendarState(options) {
        var _this = this;
        this._name = uuid();
        this._startDate = moment().startOf('month').format(YYYYMMDD);
        this._mode = 'month';
        this._fullHeight = false;
        this._fitInnerToAvailableHeight = false;
        this._displayTimelinesInWeekMode = false;
        this._showEventEndTimes = false;
        this._eventTypeGroups = [];
        this.options = defaultBaseCalendarStateOptions;
        options && (this.options = options);
        reaction(function () { return _this.mode; }, function () {
            _this.autoSetStartDate();
        });
        this.startDate = moment().startOf(this.mode).format(YYYYMMDD);
        makeAutoObservable(this);
    }
    BaseCalendarState.prototype.getKey = function (key) {
        // @ts-ignore
        return this.options ? this.options[key] : this['_' + key];
    };
    BaseCalendarState.prototype.setKey = function (key, value) {
        // @ts-ignore
        if (this.options)
            this.options[key] = value;
        // @ts-ignore
        else
            this['_' + key] = value;
    };
    Object.defineProperty(BaseCalendarState.prototype, "name", {
        get: function () { return this.getKey('name'); },
        set: function (value) { this.setKey('name', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "startDate", {
        get: function () { return this.getKey('startDate') || this._startDate; },
        set: function (value) { this.setKey('startDate', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "mode", {
        get: function () { return this.getKey('mode') || 'month'; },
        set: function (value) { this.setKey('mode', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "fullHeight", {
        get: function () { return this.getKey('fullHeight') || false; },
        set: function (value) { this.setKey('fullHeight', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "fitInnerToAvailableHeight", {
        get: function () { return this.getKey('fitInnerToAvailableHeight') || false; },
        set: function (value) { this.setKey('fitInnerToAvailableHeight', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "displayTimelinesInWeekMode", {
        get: function () { return this.getKey('displayTimelinesInWeekMode') || false; },
        set: function (value) { this.setKey('displayTimelinesInWeekMode', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "showEventEndTimes", {
        get: function () { return this.getKey('showEventEndTimes') || false; },
        set: function (value) { this.setKey('showEventEndTimes', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "eventTypeGroups", {
        get: function () { return this.getKey('eventTypeGroups') || []; },
        set: function (value) { this.setKey('eventTypeGroups', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "shouldDisplayAsTimeline", {
        get: function () {
            return this.mode === 'week' && this.displayTimelinesInWeekMode;
        },
        enumerable: false,
        configurable: true
    });
    BaseCalendarState.prototype.autoSetStartDate = function () {
        this.startDate = this.startDateMoment.startOf(this.mode).format(YYYYMMDD);
    };
    Object.defineProperty(BaseCalendarState.prototype, "startDateMoment", {
        get: function () {
            return moment(this.startDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseCalendarState.prototype, "endDateMoment", {
        get: function () {
            return moment(this.startDate).endOf(this.mode);
        },
        enumerable: false,
        configurable: true
    });
    return BaseCalendarState;
}());
export { BaseCalendarState };
